const languageKey = "language-issue";
export const getLanguage = () => localStorage.getItem(languageKey);
export const setLanguage = (language) =>
  localStorage.setItem(languageKey, language);
